/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import Button from '@material-ui/core/Button';

import EventDispatcher from '../../state/reducers/EventDispatcher';
import StatusTracking from '../../common/StatusTracking';
import { cipher } from '../../utils/crypto';
import configENV from '../../config';

const { PERSIST_KEY } = configENV;

class OrderListItem extends React.Component {
    handleViewDetailsClicked = (
        uuid,
        orderNumber,
        paymentStatus,
        status,
        trackingNumber,
        carrier,
    ) => {
        const { match, fetchOrderDetails, history: { push } } = this.props;
        // If guest user clicked on the view details button, call fetchOrderDetails to update the order details page
        if (uuid && match.params && match.params.uuid === uuid) {
            fetchOrderDetails(uuid, orderNumber, null, {
                update: true,
                paymentStatus,
                status,
                trackingNumber,
                carrier,
            });
        } else if (uuid) {
            // if logged in user clicked on the view details button, redirect to the order detail page
            const cipherKey = uuid.slice(0, 8);
            const cryptedOrderNumber = cipher(cipherKey)(orderNumber).replace(
                /^(.{8})(.{4})(.{4})(.{4})(.+)$/,
                '$1-$2-$3-$4-$5',
            );
            const validStatus = status || paymentStatus;
            const cryptedStatus = cipher(cipherKey)(validStatus).replace(
                /^(.{8})(.{4})(.{4})(.{4})(.+)$/,
                '$1-$2-$3-$4-$5',
            );
            push([
                '/account/orders/',
                uuid,
                '/',
                cryptedOrderNumber,
                '/0/',
                cryptedStatus,
            ].join(''));
        }
    };

    render() {
        const {
            order: { uuid, orderNumber, items },
            className,
            userProfile,
        } = this.props;
        if (!userProfile) {
            return null;
        }
        const hasAuthenticated = userProfile?.isAuthenticated || '';
        const hasOrderSpecific = orderNumber.includes('3410286682');
        return (
            <div className={`orderListItem ${className}`}>
                <div className="align-right small margin-bottom">
                    Order #: {orderNumber}
                </div>
                {items.map((item, i) => (
                    <React.Fragment key={['_', i].join('')}>
                        <div className="orderListProduct">
                            <div className="split margin-bottom-2x">
                                <div>
                                    <div className="bold">
                                        {item.recpFirstName} {item.recpLastName}
                                    </div>
                                    <div className="small uppercase">
                                        {item.businessName
                                            ? item.businessName
                                            : ''}
                                    </div>
                                </div>
                                {
                                    hasOrderSpecific ? <div /> : (
                                        hasAuthenticated && (
                                            <Button
                                                variant="contained"
                                                className="buttonBlue"
                                                onClick={() => this.handleViewDetailsClicked(
                                                    uuid,
                                                    orderNumber,
                                                    item.paymentStatus,
                                                    item.status,
                                                    item.trackingNumber,
                                                    item.carrier,
                                                )}
                                            >
                                                {item.modifyOrder === 'true'
                                                    ? 'View Details / Modify'
                                                    : 'View Details'}
                                            </Button>
                                        )

                                    )
                                }

                            </div>
                            <StatusTracking
                                status={item.status || item.paymentStatus}
                            />
                        </div>
                    </React.Fragment>
                ))}
            </div>
        );
    }
}

OrderListItem.defaultProps = {
    match: {},
    history: {},
    className: '',
};

OrderListItem.propTypes = {
    order: PropTypes.object.isRequired,
    match: PropTypes.object,
    history: PropTypes.object,
    className: PropTypes.string,
    fetchOrderDetails: PropTypes.func.isRequired,
    userProfile: PropTypes.shape({
        isAuthenticated: PropTypes.bool.isRequired,
    }).isRequired,
};

const mapStateToProps = (state) => {
    /* istanbul ignore next */
    const newState = state[PERSIST_KEY] ? state[PERSIST_KEY] : state;
    return {
        isAuthenticated: newState.isAuthenticated,
    };
};

const mapDispatchToProps = (dispatch) => ({
    fetchOrderDetails: (uuid, orderNumber, zipCode, options) => dispatch(EventDispatcher.fetchOrderDetails(
        uuid,
        orderNumber,
        zipCode,
        options,
    )),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(OrderListItem));
